import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { config } from '../config';

export type PermissionAppliesTo = 'Device' | 'Org' | 'Div' | 'View' | 'Region' | 'Gateway' | 'Credential' | 'User' | 'Team' | 'Context';

export interface Permission {
  id: string;
  name: string;
  description?: string;
  appliesTo: PermissionAppliesTo;
}

interface PermissionsListResponse {
  permissions: Permission[];
}

const backendApi = config.backendApi;

const fetchPermissions = async (): Promise<Permission[]> => {
  const response = await axios.get<PermissionsListResponse>(`${backendApi}/api/permissions`, { withCredentials: true });
  return response.data.permissions;
};

// Permissions are global - not organization-specific
export function usePermissions() {
  return useQuery<Permission[]>({
    queryKey: ['permissions'],
    queryFn: fetchPermissions,
  });
}
